// extracted by mini-css-extract-plugin
module.exports = {"header":"product-details_header_139ev","link":"product-details_link_1puC0"};